import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { List, Layout, Button, Row, Col, Input } from "antd";
import api from "../../Api";
import languages from "../Languages/languages.json";

const { Content } = Layout;
const { Search } = Input;

const PostsDataView = () => {
  const [posts, setPosts] = useState([]);
  const [nextId, setNextId] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPosts = async () => {
      const res = await api.blog().get();
      setNextId(
        Math.max.apply(
          Math,
          res.data.map(function (o) {
            return o.id;
          })
        ) + 1
      );
      setPosts(res.data);
      setLoading(false);
    };
    getPosts();
  }, []);

  const handleOnSearch = (value) => {
    api
      .blog()
      .get()
      .then((res) => {
        if (!value) {
          setPosts(res.data);
        } else {
          setPosts(
            posts.filter(
              (post) =>
                post.title &&
                post.title
                  .find((x) => x.languageCode === languages[0].code)
                  .text.toUpperCase()
                  .includes(value.toUpperCase())
            )
          );
        }
      });
  };

  return (
    <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
      <Row type="flex" justify="space-between" align="middle">
        <Col span={6}>
          <h1>Posts</h1>
        </Col>
        <Col span={12}>
          <Search
            type="text"
            name="search"
            enterButton="Search"
            placeholder="input search text"
            onSearch={handleOnSearch}
          />
        </Col>
        <Col span={6}>
          <div className="addNew">
            <Link to={{ pathname: `/post/?postID=${nextId}&isNew=true` }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                className="green-btn"
              >
                Add new
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
      <div
        style={{
          padding: 24,
          background: "#fff",
          textAlign: "left",
          borderRadius: 12,
        }}
      >
        <List
          itemLayout="horizontal"
          loading={loading}
          pagination={{
            onChange: (page) => {
              console.log(page);
            },
          }}
          dataSource={posts}
          renderItem={(post) => (
            <List.Item key={post.id}>
              <List.Item.Meta
                title={
                  post.title &&
                  post.title.some((x) => x.languageCode === languages[0].code)
                    ? post.title.find(
                        (x) => x.languageCode === languages[0].code
                      ).text
                    : ""
                }
                description={
                  post.excerpt &&
                  post.excerpt.some((x) => x.languageCode === languages[0].code)
                    ? post.excerpt.find(
                        (x) => x.languageCode === languages[0].code
                      ).text
                    : ""
                }
              />
              <Link to={{ pathname: `/post/?postID=${post.id}` }}>
                <Button>Show/Edit</Button>
              </Link>
            </List.Item>
          )}
        />
      </div>
    </Content>
  );
};
export default PostsDataView;
